require.config({
    baseUrl: '/assets'
});

requirejs(['lib/web-assets/javascripts/features/login/views'], function(views) {
    "use strict";
    window.Feature = {
        Urls: {},
        Views: views,
        init: function(){
            KMD.Views.getView('defaultView').render();
        }
    };
    KMD.register(window.Feature);
});
define("lib/web-assets/javascripts/features/login/main", function(){});

